<template>
    <a :href="showcaseUrl" class="showcase-card" :class="portfolioClass">
        <img :src="image" :alt="imageAlt" class="showcase-card__image" />
        <div class="showcase-card__content-wrap">
            <div class="showcase-card__style">{{ styleName }}</div>
            <div class="showcase-card__title balance-text">{{ title }}</div>
            <div class="showcase-card__photographer-designer" v-if="credits" v-html="strippedCredits"></div>
            <div class="showcase-card__ctas">
                <span class="btn btn-outline-white">Learn More</span>
            </div>
        </div>
    </a>
</template>

<script lang="ts">
import * as balanceText from 'Lib/balanceText.js';

export default {
    name: 'ShowcaseCard',
    props: {
        credits: {
            type: String,
            Default: '',
        },
        url: {
            type: String,
            default: '',
        },
        index: {
            type: Number,
            default: 0,
        },
        styleValue: {
            type: String,
            default: '',
        },
        styleName: {
            type: String,
            default: '',
        },
        portfolio: {
            type: String,
            default: '',
        },
        portfolioName: {
            type: String,
            default: '',
        },
        title: {
            type: String,
            default: '',
        },
        image: {
            type: String,
            default: '',
        },
        imageAlt: {
            type: String,
            default: '',
        },
    },
    computed: {
        portfolioClass: function () {
            if (this.portfolio) {
                return `showcase-card--${this.portfolio}`;
            } else {
                return '';
            }
        },
        showcaseUrl: function () {
            /**
             * The path
             */
            let path = window.location.href;
            let pathWithoutParams = path.indexOf('?') !== -1 ? window.location.href.split('?')[0] : window.location.href;
            const last = pathWithoutParams.charAt(pathWithoutParams.length - 1);

            if (last === '/') {
                return `${pathWithoutParams}${this.url}`;
            } else {
                return `${pathWithoutParams}/${this.url}`;
            }
        },
        strippedCredits: function () {
            return this.credits.replace(/<a\b[^>]*>/i, '').replace(/<\/a>/i, '');
        },
    },
    created() {
        balanceText();
    },
};
</script>
